'use client';
import {useEffect, useRef, useState} from 'react';

export default function DragBtnList({moduleOption}: {moduleOption: any}) {
  const dragItems = moduleOption?.items || [];
  const scrollRef = useRef<HTMLDivElement>(null);
  const constraintsRef = useRef<HTMLDivElement>(null);

  const [showLeftBtn, setShowLeftBtn] = useState(false);
  const [showRightBtn, setShowRightBtn] = useState(true);
  const isDragging = useRef(false);

  // 檢查邊界邏輯
  const checkScrollLimits = () => {
    if (scrollRef.current) {
      const {scrollLeft, scrollWidth, clientWidth} = scrollRef.current;
      setShowLeftBtn(scrollLeft > 5);
      setShowRightBtn(scrollLeft < scrollWidth - clientWidth - 5);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScrollLimits();
    el.addEventListener('scroll', checkScrollLimits);
    return () => el.removeEventListener('scroll', checkScrollLimits);
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const moveDistance = scrollRef.current.clientWidth * 0.8 - 72; // 72 = nav-btn width
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -moveDistance : moveDistance,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div
      className="relative-wrapper"
      style={{position: 'relative', width: '100%'}}
    >
      <div className={`nav-btn-block left ${showLeftBtn ? 'active' : ''}`}>
        <button
          onClick={() => scroll('left')}
          className={`nav-btn `}
          aria-hidden={!showLeftBtn}
        >
          ←
        </button>
      </div>
      <div
        ref={scrollRef}
        className="scroll-container"
        style={{
          overflowX: 'auto',
          display: 'flex',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch', // 啟用 iOS 慣性捲動
          cursor: 'grab'
        }}
        onMouseDown={(e) => {
          isDragging.current = false;
          const startX = e.pageX - scrollRef.current!.offsetLeft;
          const scrollLeft = scrollRef.current!.scrollLeft;

          const mouseMoveHandler = (em: MouseEvent) => {
            const x = em.pageX - scrollRef.current!.offsetLeft;
            const walk = (x - startX) * 1.5; // 捲動倍率
            if (Math.abs(walk) > 5) isDragging.current = true;
            scrollRef.current!.scrollLeft = scrollLeft - walk;
          };

          const mouseUpHandler = () => {
            window.removeEventListener('mousemove', mouseMoveHandler);
            window.removeEventListener('mouseup', mouseUpHandler);
          };

          window.addEventListener('mousemove', mouseMoveHandler);
          window.addEventListener('mouseup', mouseUpHandler);
        }}
      >
        <div
          className="list-wrapper"
          style={{display: 'flex', gap: '16px', width: 'max-content'}}
        >
          {dragItems.map((item: any, index: number) => (
            <a
              key={index}
              className="btn"
              href={item.url}
              onClick={(e) => {
                if (isDragging.current) e.preventDefault();
              }}
              onDragStart={(e) => e.preventDefault()}
            >
              {item.text}
            </a>
          ))}
        </div>
      </div>

      <div className={`nav-btn-block right ${showRightBtn ? 'active' : ''}`}>
        <button
          onClick={() => scroll('right')}
          className={`nav-btn  `}
          aria-hidden={!showRightBtn}
        >
          →
        </button>
      </div>

      <style jsx>{`
        .scroll-container::-webkit-scrollbar {
          display: none;
        }
        .scroll-container:active {
          cursor: grabbing;
        }
        .nav-btn-block {
          background: white;
          position: absolute;
          top: 50%;
          opacity: 0;
          transition:
            transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
            opacity 0.3s ease;
          pointer-events: none;
          z-index: 10;
        }
        .nav-btn-block.left {
          left: 0px;
          transform: translateY(-50%) translateX(-100%);
        }

        .nav-btn-block.right {
          right: 0px;
          transform: translateY(-50%) translateX(100%);
        }

        .nav-btn-block.active {
          opacity: 1;
          transform: translateY(-50%) translateX(0) !important;
          pointer-events: auto;
        }

        .nav-btn {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: #faefeb;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 500;
          transition:
            background 0.3s,
            transform 0.2s;
        }

        .nav-btn-block.active .nav-btn {
          pointer-events: auto;
        }

        .nav-btn-block.left .nav-btn {
          margin-right: 16px;
        }
        .nav-btn-block.right .nav-btn {
          margin-left: 16px;
        }

        .nav-btn:hover {
          background: #ffd0ce;
        }

        .btn {
          user-select: none;
          pointer-events: auto;
          padding: 12px 32px;
          border-radius: 100px;
          background: #faefeb;
          color: #3f3c3b;
          text-decoration: none;
          white-space: nowrap;
          display: inline-block;
        }
        .btn:hover {
          background: #ffd0ce;
        }
      `}</style>
    </div>
  );
}
